import React from "react";
import { useNavigate } from "react-router-dom";
import "./NotFound.css";

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="nf-wrapper">
            <div className="nf-card">

                {/* Left Content */}
                <div className="nf-content">
                    <h1 className="nf-code">404</h1>
                    <h2 className="nf-title">Oops! Page Not Found</h2>
                    <p className="nf-description">
                        The page you are looking for might have been removed,
                        had its name changed, or is temporarily unavailable.
                    </p>

                    <div className="nf-actions">
                        <button
                            className="nf-btn-primary"
                            onClick={() => navigate("/")}
                        >
                            Go Home
                        </button>

                        <button
                            className="nf-btn-secondary"
                            onClick={() => navigate(-1)}
                        >
                            Go Back
                        </button>
                    </div>
                </div>

                {/* Right Image */}
                <div className="nf-image-section">
                    <img
                        src="https://cdn-icons-png.flaticon.com/512/2748/2748558.png"
                        alt="404 Illustration"
                        className="nf-image"
                    />
                </div>

            </div>
        </div>
    );
};

export default NotFound;